import {curry} from 'ramda';
import {Action} from 'redux-actions';
import {Dispatch} from 'redux';
import {logOutAction} from '../../Login/Redux/LoginActions';

export const unauthorizedLogout = curry((store: any, dispatch: Dispatch, action: Action<any>) => {
    if (action.error && action.payload?.response?.status === 401) {
        return dispatch(logOutAction());
    }
    dispatch(action);
});
